import { useState } from "react"
import { CouponEntity } from "../../Objects/Coupon/CouponEntity"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"

export const useCreateCoupon = () => {
  const [code, setCode] = useState("")

  const [discountPercentage, setDiscountPercentage] = useState("0")

  const [status, setStatus] = useState<EEnableStatusType>(EEnableStatusType.Active)

  const [hasPerCustomerUsageLimit, setHasPerCustomerUsageLimit] = useState(true)
  const [maxUsagePerCustomer, setMaxUsagePerCustomer] = useState("1")

  const [hasGlobalUsageLimit, setHasGlobalUsageLimit] = useState(false)
  const [maxUsageTotal, setMaxUsageTotal] = useState("100")

  const [coupon, setCoupon] = useState<CouponEntity | null>(null)

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => setCode(e.target.value.toUpperCase())
  const handleDiscountPercentageChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setDiscountPercentage(e.target.value)

  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setStatus(e.target.selectedIndex as EEnableStatusType)

  const handleInitialValue = (myCoupon: CouponEntity | null | undefined) => {
    if (myCoupon) {
      setCoupon(myCoupon)
      setCode(myCoupon.code)
      setDiscountPercentage(myCoupon.discountPercentage.toString())
      setStatus(myCoupon.status)

      setHasPerCustomerUsageLimit(myCoupon.hasPerCustomerUsageLimit)
      setMaxUsagePerCustomer((myCoupon.maxUsagePerCustomer ?? 1).toString())

      setHasGlobalUsageLimit(myCoupon.hasGlobalUsageLimit)
      setMaxUsageTotal((myCoupon.maxUsageTotal ?? 100).toString())
    }
  }

  const handleSubmitForm = () => {
    return new CouponEntity({
      id: coupon?.id ?? -1,
      code,
      discountPercentage: Number(discountPercentage),
      status,
      hasPerCustomerUsageLimit,
      maxUsagePerCustomer: hasPerCustomerUsageLimit ? Number(maxUsagePerCustomer) : undefined,
      hasGlobalUsageLimit,
      maxUsageTotal: hasGlobalUsageLimit ? Number(maxUsageTotal) : undefined,
    })
  }

  return {
    coupon,
    code,
    discountPercentage,
    status,
    hasPerCustomerUsageLimit,
    maxUsagePerCustomer,
    hasGlobalUsageLimit,
    maxUsageTotal,

    setCoupon,
    setStatus,
    setHasPerCustomerUsageLimit,
    setMaxUsagePerCustomer,
    setHasGlobalUsageLimit,
    setMaxUsageTotal,

    handleCodeChange,
    handleDiscountPercentageChange,
    handleStatusChange,
    handleInitialValue,
    handleSubmitForm,
  }
}
